/* @flow */

type State = {
  +requestCount: number
};

export const INITIAL_STATE = { // Exporting it for test purposes
  requestCount: 0,
};

// TODO restrict length of state array

export default (state: State = INITIAL_STATE, action: AnyAction) => {
  const { requestCount } = state;

  if (action.type === 'NETWORK_REQUEST_STARTED') {
    return { ...state, requestCount: requestCount + 1 };
  } if (action.type === 'NETWORK_REQUEST_ENDED') {
    return { ...state, requestCount: requestCount - 1 };
  }

  return state;
};
